
export default {
  home: {
    Home: 'Live',
    Hot: 'Populer',
    Match: 'Jadwal',
    Message: 'Pesan',
    Friend: 'Teman',
    Me: 'Profile',
    Tab_0: 'Beranda',
    Tab_1: 'Sepak Bola',
    Tab_2: 'Basket',
    Tab_3: 'Esports',
    Tab_4: 'Berita',
    Tab_5: 'Pertandingan tengah malam',
    Tab_6: 'Ulang',
    index_title_zb: 'Match Populer',
    index_title_jc: 'Kumpulan sorotan/Highlight',
    index_title_mx: 'Host bintang',
    index_title_qq: 'Esports',
    index_title_kx: 'Berita hari ini',
    more: 'Lainnya',
    jrrm: 'Populer Hari Ini',
    jumpTop: 'Ke Atas',
    onFocus: 'Ikuti',
    reply: 'Balasan',
    allComment: 'Semua Komentar',
    remen: 'Populer',
    saiguo: 'Hasil',
    bsjj: 'Highlight Pertandingan',
    qwzk: 'Gratis & HD',
    lggg: 'Dapatkan Di Playstore & Appstore',
    downapp: 'Unduh',
    anchortalk: 'Komentar Host',
    currentsound: 'Suara Asli',
    movieplayback: 'Rekaman',
    hightqulity: 'HD',
    pushlish: 'Launch',
    abautanchor: 'Tentang Host',
    areadyfocus: 'Done',
    focus: 'Ikuti',
    abautlive: 'Live Terkait',
    abautmatch: 'Jadwal Terkait',
    yi: 'Ratus juta',
    wan: 'Puluh ribu',
    unkowntype: 'Tipe Tidak Diketahui',
    ballcircle: 'Komunitas Bola',
    staranchor: 'Host Bintang',
    renhot: 'Popularitas',
    veryonesearch: 'Semua Orang Mencari',
    searchplace: 'Cari Konten Kesukaanmu',
    zhongyao: 'Host',
    worldCupSchedule: 'Jadwal',
    worldCupScore: 'Skor',
    worldCupNews: 'Berita',
    tabIdx: '2',
  },
  play: {
    chat: 'Chat',
    userzb: 'Host',
    saik: 'Skor',
    zr: 'Formasi',
    zs: 'Indeks',
    zb: 'Live',
    fx: 'Analisis',
    zbNoLine: 'Host Sementara Tidak Live',
    zbNoLine2: 'Ikuti host dapatkan notifikasi live',
    joinInRoom: 'bergabung ke ruang obrolan',
    textLive: 'Live Teks',
    tongji: 'Statistik Teknis',
    team: 'Tim',
    teamTj: 'Statistik Tim',
    teamUserTj: 'Statistik Pemain',
    yz: 'Handicap Asia',
    rq: 'Handicap',
    jqs: 'Jumlah Gol',
    zf: 'Total Skor',
    zlly: 'Sumber Odds',
    fhv: 'Rasio Payout',
    win: 'Menang',
    draw: 'Seri',
    owe: 'Kalah',
    number: 'Nomor',
    teamUser: 'Pemain',
    starter: 'Pemain',
    time: 'Waktu',
    score: 'Skor',
    lb: 'Rebound',
    zg: 'Assist',
    tl: 'Shooting',
    sanfen: '3 Poin',
    fq: 'Free Throw',
    qd: 'Tekel',
    qb: 'Rb Serang',
    hb: 'Rb Bertahan',
    gm: 'Block',
    sw: 'Turnover',
    fg: 'Foul',
    chatText: 'Lebih seru kalau dibahas bareng~',
    gxzg: 'Rekor Tertinggi',
    lsjz: 'Rekor pertemuan',
    sv: 'Win Rate',
    ypl: 'Rate Menang Handicap',
    dql: 'Persentase Over',
    ying: 'Menang',
    shu: 'Kalah',
    zou: 'Draw',
    xiao: 'Under',
    da: 'Over',
    jqzt: 'Status Terkini',
    tss: 'Dalam Pertandingan Ini',
    rqss: 'Tgl',
    dz: 'H2H',
    dx: 'Over/Under',
    copyline: 'Salin Tautan',
    sixin: 'Pesan',
    fensi: 'Followers',
    fds: 'Untuk mencegah hilang, ingat domain cadangan',
    ordownapp: 'atau unduh aplikasi',
    lodingtext: 'Memuat obrolan',
    disstartmatch: 'Waktu Mulai Pertandingan',
    zhu: 'Tuan rumah',
    ke: 'Tamu',
    chatHost: 'DM penyiar',
  },
  match: {
    jumpNowDay: 'Kembali ke Hari Ini',
    refresh: 'Refresh',
    mathDay: 'Tanggal Pertandingan',
    ban: 'First half',
    jiao: 'Second half',
    huangguan: 'Crown',
    libo: 'BetFair',
    mingh: 'Mansion88',
    bocai: '188 Bet',
    wlxe: 'William Hill',
    ysb: 'SBOBET',
    wd: 'W88',
    lij: 'LadBrokes',
    yih: 'DafaBet',
    pb: 'Pinnacle',
    year: 'Tahun',
    moon: 'Bulan',
    nowDay: 'Hari Ini',
    onlive: 'Live',
    dej: 'Q2',
    matcherr: 'Gangguan',
    nomatch: 'Belum',
    dyj: 'Q1',
    dyjo: 'Q1 Selesai',
    dejo: 'Q2 Selesai',
    dsj: 'Q3',
    dsjo: 'Q3 Selesai',
    dsjj: 'Q4',
    matchjs: 'Tambahan',
    matchwc: 'Selesai',
    matchtc: 'Tunda',
    matchzd: 'Putus',
    matchyz: 'Henti',
    matchdd: 'TBD',
    matchsfqrqs: '3 Poin',
    matchefqrqs: '2 Poin',
    matchfqjqs: 'Bebas',
    matchsyzts: 'Sisa TO',
    matchfgs: 'Foul',
    matchfqmzl: '% Bebas',
    matchzzts: 'Total TO',
    matchzg: 'Serangan',
    matchwxjg: 'Serang Bahaya',
    matchkql: 'Penguasaan',
    matchszqm: 'Tepat',
    matchjq: 'Gol',
    matchdq: 'Penalti',
    matchzg1: 'Assist',
    matchtime: 'Waktu',
    matchhp: 'Merah',
    matchhp2: 'Kuning',
    matchsm: 'Tembakan',
    matchsz: 'Tepat',
    matchgr: 'Dribble',
    matchgrcg: 'Sukses',
    matchjw: 'Clear',
    matcyxzd: 'Blok',
    matclj: 'Intersep',
    matcqd: 'Steal',
    matccq: 'Umpan',
    matccqcg: 'Passing',
    matchczq: 'Crossing',
    matchczqcg: 'Throughball',
    matchcco: 'LongPass',
    matchccok: 'Penetrating',
    matchpq: 'Duel',
    matchpqcg: 'Intercept',
    matchdqe: 'Pressing',
    matchfg: 'Foul',
    matchbqf: 'Dilanggar',
    matchpj: 'Save',
    matchqjq: 'Tinju',
    matchsmycj: 'Attacking',
    matchcjcg: 'Save',
    matchgkcj: 'Heading',
    matchpf: 'Skor',
    matchjqs: 'Pojok',
    matchjwq: 'Lemparan Kedalam',
    matchryq: 'Tendangan Bebas',
    matchqmq: 'Tendangan Gawang',
    matchhr: 'Sub',
    matchbsks: 'Kick Off',
    matchzc: 'Half Time',
    matchjsg: 'Full Time',
    matchbcbf: 'Skor Babak Pertama',
    matchlhbh: 'Kuning',
    matchdqwj: 'Gagal',
    matchwlq: 'Bunuh',
    matchstbs: 'Injury Time',
    matchsp: 'Melenceng',
    matchjssjs: 'Akhir Perpanjangan Waktu',
    matchjdqdz: 'Akhir Adu Penalti',
    matchvar: 'VAR',
    matchspqm: 'Tendangan Melenceng',
    matchzysj: 'Highlight Penting',
    matchjss: 'Tambahan',
    matchdqjs: 'Penalti',
    no: 'Tidak Ada',
    chang: ' Match',
    tzk: 'Tuan Tamu Sama',
    yes: 'Ya',
    nos: 'Tidak',
    xiaojie: 'Bagian',
    noLiveMatch: 'Tidak Ada Siaran Langsung',
  },
  noData: {
    noComment: 'Belum ada komentar, bagikan pendapatmu',
    noSearch: 'Tidak ada hasil pencarian',
    noMatch: 'Tidak ada pertandingan saat ini',
    nobifen: 'Tidak ada data skor',
    noLive: 'Lihat Pertandingan Lain',
    nogroup: 'Belum ada grup yang ditambahkan',
    noNewfriend: 'Tidak ada permintaan teman baru',
    noqgg: 'Jelajahi dan jangan lupa untuk follow jika kamu menemukan host favorit',
    nozb: 'Belum mengikuti host',
    noMsg: 'Tidak ada pesan',
  },
  tips: {
    shareMatch: 'Pertandingan berhasil dibagikan',
    copySuccess: 'Berhasil disalin',
    changeLine: 'Ganti jalur video',
    line: 'Channel',
    cancel: 'Batal',
    tosendZb: 'Segera minta kepada host untuk bergabung ke grup',
    tosendhd: 'Ayo ngobrol dengan host favorit kamu',
    addzb: 'Ayo tambahkan host sebagai teman agar tidak tertinggal info menarik',
    gd: 'Tambah host sebagai teman',
    tickoutgroup: 'Anda telah dikeluarkan dari grup chat',
    youforbid: 'Anda telah dibisukan',
    younotin: 'Ruang chat tidak ditemukan',
    nomoredata: 'Tidak ada lagi',
    month: 'Bulan',
    day: 'Hari',
    today: 'Hari ini',
    kkry: 'Kosong~',
    ptaddress: 'Link alternatif ',
    downloadApp: 'Unduh',
    qwzk: 'Layanan Gratis & HD Terbaik',
    lgtp: 'Unduh Sekarang di Appstore & Playstore',
    myInvite: 'Undangan Saya',
    gjyaoqing: 'Total undangan',
    copyInviteLink: 'Salin dan bagikan tautan',
    person: '',
    chatcontent: 'Isi chat',
    addHomeScreen: 'Tambah ke Utama',
    beat40: 'Anda telah mengalahkan 40% pengguna di seluruh negeri',
    beat60: 'Anda telah mengalahkan 60% pengguna di seluruh negeri',
    beat78: 'Anda telah mengalahkan 78% pengguna di seluruh negeri',
    beat88: 'Anda telah mengalahkan 88% pengguna di seluruh negeri',
    beat98: 'Anda telah mengalahkan 98% pengguna di seluruh negeri',
    haicha: 'Kurang ',
    czzksj: ' poin untuk naik level',
    forbid: 'Dibisukan',
    loadFail: 'Gagal memuat',
    notSuport: 'Browser Anda tidak mendukung video',
    forwardApp: 'Tipe pesan ini tidak didukung, silakan cek di app',
    photo: 'Foto',
    video: 'Video',
    file: 'File',
    redpot: 'Angpao',
    upload: 'Mengunggah',
    uploadFail: 'Gagal mengunggah!',
    yybtcql: 'Anda telah dikeluarkan dari grup chat',
    yybjy: 'Anda telah dibisukan',
    ltsbcz: 'Ruang chat tidak ada',
    sunday: 'Minggu',
    monday: 'Senin',
    tuesday: 'Selasa',
    wednesday: 'Rabu',
    thursday: 'Kamis',
    friday: 'Jumat',
    saturday: 'Sabtu',
    search: 'Cari',
  },
  im: {
    edit: 'Edit',
    search: 'Cari',
    inputPlaceholder: 'Masukkan kata kunci pencarian',
    allin: 'Semua',
    add: 'Tambah',
    group: 'Obrolan Grup',
    agree: 'Disetujui',
    reject: 'Ditolak',
    pass: 'Lewati',
    subitFriend: 'Ajukan sebagai teman',
    activity: 'Acara',
    sedkf: 'Bagikan pendapatmu',
    allSel: 'Pilih Semua',
    yidu: 'Tandai telah dibaca',
    wanc: 'Selesai',
    online: 'Online',
    nowonline: 'Online',
    latestonline: 'Baru-baru ini Online',
    contact: 'Kontak',
    newFriend: 'Teman Baru',
    mygfoup: 'Grup Saya',
    mygscj: 'Gabung grup bersama host',
    wntuij: 'Rekomendasi Untuk Anda',
    sound: '[Suara]',
    video: '[Video]',
    image: '[Gambar]',
    redpot: '[Angpao]',
    link: '[Tautan]',
    card: '[Kartu Nama]',
    getredpot: 'Klaim Angpao',
    getreadysound: 'Bersiap untuk Real-Time Voice',
    transfer: '[Transfer]',
    groupcard: '[Kartu Nama Grup]',
    recall: 'Tarik Pesan',
    checkorder: '[Konfirmasi Pesanan]',
    file: '[File]',
    zfhxx: '[Pesan Nomor Pembayaran]',
    pay: '[Mini Program]',
    ad: '[Iklan]',
    talkover: '[Panggilan Berakhir]',
    tips: '[Tips]',
    grouptips: '[Tips Permintaan Grup]',
    groupconfirm: '[Konfirmasi Permintaan Grup]',
    notyoufriend: '[Bukan Teman Anda]',
    linknotyoufriend: '[Link Undangan Grup]',
    groupsend: '[Kirim ke Grup]',
    groupNotice: 'Group Notice',
    shouqi: 'Collapse',
    zhangkai: 'Expand',
    groups: 'Group'
  },
  me: {
    onLogin: 'Masuk',
    tipsregst: ' Daftar untuk lebih banyak keuntungan',
    sign: 'Absen',
    onsign: 'Selesai',
    jfsc: 'Toko',
    zbxg: 'Ikuti',
    gkls: 'Riwayat',
    wddj: 'Peringkat Saya',
    yqhy: 'Undang Teman',
    zxkf: 'Layanan Pelanggan',
    zxzh: 'Hapus Akun',
    yqhydjf: 'Undang teman dapat poin',
    yjfk: 'Masukan',
    gywm: 'Tentang Kami',
    setting: 'Pengaturan',
    lvxl: 'New person',
    lvht: 'Brass',
    lvby: 'Silver',
    lvhj: 'Gold',
    lvbj: 'Platinum',
    lvzs: 'Diamond',
    lvbyqt: 'Ball-boy perak',
    lvhtqm: 'Fans Tembaga',
    lvhjqy: 'Pemain Emas',
    lvbjqx: 'Bintang Platinum',
    lvzsqw: 'Raja Berlian',
    srmi: 'Masukkan sandi',
    qdcg: 'Check-in berhasil',
    jfgz: 'Aturan Poin',
    text3: '3: Dapatkan poin dengan menonton pertandingan selama 10 menit setiap hari',
    text1: '1: Toko Poin adalah fasilitas gratis dari platform kami untuk semua pengguna. Dengan menjadi pengguna kami, Anda bisa mendapatkan poin. Poin dapat ditukar dengan hadiah bernilai tinggi atau manfaat lainnya di platform.',
    text1_2: '1: Toko Poin adalah fasilitas gratis dari platform kami untuk semua pengguna. Dengan menjadi pengguna kami, Anda bisa mendapatkan poin. Poin dapat ditukar dengan hadiah bernilai tinggi.',
    sigin1: 'Pengguna ini malas, belum mengisi bio',
    quxiaocg: 'Berhasil membatalkan',
    fzfxlj: 'Salin tautan untuk berbagi',
    addimg: 'Tambah gambar',
    zonecodedef: '62',
    inputphone: 'Nomor telepon',
    videohp: 'Video layar gelap',
    mbf: 'Tidak ada skor',
    sxcg: 'Berhasil memperbarui',
    qsrplnr: 'Silakan ketik komentar',
    srname: 'Ketik nama Anda',
    tgcggg: 'Pengajuan berhasil, staf kami akan menghubungi Anda segera',
    zbxxsc: 'Upload Informasi Host',
    qsrsfz: 'Silakan masukkan nomor KTP',
    zbnoid: 'Host tidak menetapkan ID',
    gzzb: 'Follow Host',
    lxkf: 'Hubungi Layanan Pelanggan',
    phone: 'Nomor telepon',
    code: 'Kode Verifikasi',
    dxyzm: 'Kode Verifikasi SMS',
    hqyzm: 'Dapatkan',
    symmdl: 'Masuk dengan Kata Sandi',
    dl: 'Masuk',
    wyydbty: 'Saya setuju',
    rjfwyx: '《Perjanjian layanan》',
    zhen: 'Akun',
    inputname: 'Masuk',
    jxgg: 'Kembali',
    yzmdl: 'Masuk dengan Kode Verifikasi',
    mm: 'Kata Sandi',
    qsrnc: 'Silakan masukkan nama panggilan',
    jrqdhd: 'Check-in Hari Ini Mendapat',
    textnone: '1.Cara Mendapatkan Poin',
    text4: '4: Undang pengguna baru untuk membagikan app',
    text2: '2: Barang di toko hanya dapat ditukar dengan poin, tidak dapat dibeli dengan uang tunai atau cara lain.',
    signname: 'Tanda Tangan',
    gzcg: 'Follow Berhasil',
    fzljcg: 'Salin Berhasil',
    zdyz: '(Maksimal satu)',
    submit: 'Kirim',
    mflt: 'Tidak bisa chat',
    bsts: 'Pertandingan Terlalu Sedikit',
    abouttext1: ' sebagai platform media olahraga generasi terbaru, memiliki hak siar lebih dari 50 liga di tingkat domestik dan internasional seperti Chinese Super League, AFC Champions League, English Premier League, Serie A, Ligue 1, La Liga, UEFA Champions League, Euro, World Cup. Selain itu aplikasi dan website ini menjadi platform bagi banyak pecinta olahraga untuk menonton, berdiskusi dan berinteraksi tentang suatu pertandingan.',
    tpisnodata: 'Anda belum memasukkan konten',
    plcg: 'Komentar Berhasil',
    srndsjh: 'Masukkan nomor telepon Anda',
    oninutphone: 'Silakan isi nomor telepon dengan benar',
    zjhm: 'Nomor Identitas',
    tccg: 'Berhasil Keluar',
    mhtcsy: 'Kembali ke halaman utama dalam beberapa detik',
    nrwk: 'Konten Kosong',
    tyfwxy: 'Harap setujui perjanjian layanan',
    qsrmm: 'Silakan masukkan kata sandi',
    newpass: 'Kata Sandi Baru',
    inputnewpass: 'Masukkan Kata Sandi Baru',
    grzl: 'Profil Pribadi',
    avatar: 'Avatar',
    username: 'Nama Panggilan',
    gxqm: 'Tanda Tangan Pribadi',
    nosetting: 'Tidak Diatur',
    xtavatar: 'Avatar Sistem',
    xc: 'Galeri',
    qxztx: 'Pilih Avatar',
    wjbncg: 'Ukuran file tidak boleh lebih dari 1MB',
    imgsubimterr: 'Gagal mengunggah gambar, silakan coba lagi nanti',
    tpscz: 'Mengunggah gambar',
    qscjpg: 'Silakan unggah gambar dalam format jpg/png',
    scz: 'Mengunggah...',
    hqsb: 'Gagal mendapatkan avatar sistem',
    szcg: 'Pengaturan berhasil',
    sznc: 'Atur Nama Nickname',
    xlqd: 'Anda telah check-in berturut-turut selama',
    tian: 'hari',
    mrqd1: '1: Check-in harian',
    mrqd2: '(Check-in berturut-turut selama 7 hari untuk mendapatkan paket poin tambahan)',
    aboutjfsc: '2. Tentang Toko Poin',
    jfdhjp: '3: Penukaran hadiah poin membutuhkan alamat, telepon dan nama penerima yang benar, platform ini akan bertanggung jawab atas pengiriman gratis ke seluruh negeri.',
    mygdl: 'Tidak ada lagi',
    zzzb: 'Live',
    fklex: 'Tipe Feedback',
    fkcgprd: '(Feedback yang berhasil berpeluang mendapatkan hadiah)',
    tgcg: 'Pengajuan berhasil',
    syhm: 'Audio dan video tidak sinkron',
    cpty: 'Pengalaman Produk',
    testx1: ' berdedikasi untuk menciptakan platform olahraga online untuk penggemar bola di seluruh dunia, dengan inovasi bisnis meluncurkan app olahraga independen, melalui penguatan interaksi, menciptakan konten olahraga yang lebih kaya, lebih komprehensif, dan menyediakan layanan konsultasi 7x24 jam.',
    ltpf: 'Obrolan terlalu sering, silakan coba lagi nanti~',
    mmbns6: 'Kata sandi tidak boleh kurang dari 6 karakter',
    srxxdz: 'Masukkan alamat lengkap Anda',
    qzqtx: 'Silakan isi informasi dengan benar',
    qsrzsmz: 'Silakan masukkan nama asli',
    nylqgl: 'Anda sudah mengklaim',
    nccccc: '1. Nickname hanya dapat diubah sekali dalam sehari, tidak boleh lebih dari 6 karakter.',
    textnc3: '2. Setelah berhasil mengubah nickname, jika ditemukan melanggar aturan setelah pemeriksaan manual, akan direset.',
    ncxt: 'Nickname sama, silakan ubah dan ajukan kembali',
    ncbnwk: 'Nickname tidak boleh kosong',
    idszh: 'ID adalah bukti akun, tidak dapat diubah',
    szgxqm: 'Atur Tanda Tangan Pribadi',
    qsrgxqm: 'Silakan masukkan tanda tangan pribadi Anda',
    qsxt: 'Tanda tangan sama, silakan ubah dan ajukan kembali',
    qsbnwk: 'Tanda tangan tidak boleh kosong',
    jfgza: 'Aturan',
    lxqdyjx: 'Absen berturut-turut, menangkan paket hadiah',
    jfmx: 'Detail Poin',
    jfdhzq: 'Zona Penukaran Poin',
    ckwdhd: 'Lihat',
    jfci: 'Poin/kesempatan',
    jf: 'Poin',
    dh: 'Tukar',
    dhsy: 'Setelah menggunakan poin untuk penukaran, tidak dapat dibatalkan',
    ckkdh: 'Lihat',
    zbgphd: '2: Interaksi di public chat live',
    zbgphd2: '(Sekali sehari)',
    smjfsc: 'Apa itu Toko Poin?',
    textp4: '4: Platform berhak menyesuaikan aturan Toko Poin kapan saja dan akan mengumumkannya. Jika terjadi kebocoran aktivitas atau perilaku curang skala besar, termasuk tapi tidak terbatas pada mendapatkan hak melalui proses yang tidak normal, platform memiliki hak untuk langsung menonaktifkan aktivitas dan mempertahankan hak untuk menarik kembali hak, serta mempertahankan hak untuk mengubah aturan dan ketentuan ini.',
    qxgz: 'Batal mengikuti',
    lsjl: 'Catatan Transaksi',
    fknr: 'Isi Feedback',
    gxydkn: 'Kesulitan saat pembaruan',
    bstk: 'Pertandingan terasa sangat lag',
    qsrnyfk: 'Silakan masukkan informasi feedback Anda',
    wl1: 'Untuk masa mendatang ',
    wlyt: ' dengan dukungan oleh ahli profesional dalam mengelola event olahraga, kami akan mengeksplorasi lintas industri dan membangun ekosistem layanan pengguna berbasis semua cabang olahraga. Kami akan berfokus pada komunitas olahraga yang menarik minat serta terus melayani pengguna olahraga dengan kemampuan operasi IP terkemuka dalam industri. Kami akan menyajikan event olahraga terkemuka dalam industri, membentuk konsultasi konten olahraga, dan menciptakan platform olahraga yang sehat. Semua ini bertujuan agar para penggemar olahraga semakin mencintai hal tersebut.',
    xtts: 'Sistem pemberitahuan: Live streaming ini berusaha menciptakan lingkungan siaran langsung yang positif dan sehat, dengan melakukan patroli konten selama 24 jam. Setiap tindakan menyebarkan informasi yang melanggar hukum, melanggar aturan, penipuan, konten yang rendah, vulgar, kekerasan darah, atau perilaku superstitious akan mengakibatkan penutupan akun pelanggar.',
    chgangsu: 'Berhasil diubah',
    inputcode: 'Masukkan kode pos Anda',
    yazfa: 'Kode verifikasi telah dikirim',
    xingming: 'Nama',
    lingquceng: 'Berhasil diklaim',
    loginSucces: 'Login berhasil',
    backhome: 'Kembali ke beranda',
    inputphonecode: 'Masukkan kode verifikasi',
    setPass: 'Atur kata sandi',
    yset: 'Sudah diatur',
    out: 'Keluar',
    setpasstips: 'Setelah mengatur kata sandi, Anda dapat langsung masuk dengan akun dan kata sandi Anda.',
    ok: 'Oke',
    pssmy: 'Verifikasi kata sandi',
    zxhb: 'Angpao khusus',
    zxhbjf: 'Angpao poin eksklusif',
    lq: 'Terima',
    ylq: 'Sudah diterima',
    mystatk: 'Tugas saya',
    mystat2k: 'Poin',
    qbtj: 'Statistik keseluruhan',
    zbgg: 'Pengumuman host',
    nozbgg: 'Host belum membuat pengumuman',
    xianlu: 'Channel',
    gxni: 'Selamat, Anda mendapatkan angpao tunai',
    gxsssni: 'Pergi ke pesan pribadi host untuk mengklaimnya~',
    loding: 'Data sedang dimuat, harap tunggu sebentar~',
    yuan: 'Rp',
    sedmsg: 'Mengirimkan Anda sebuah pesan',
    chakan: 'Lihat',
    del: 'Hapus',
    sp: 'Odds naik',
    jp: 'Odds turun',
    gs: 'Odds tinggi',
    ds: 'Odds rendah',
    pkly: 'Sumber odds',
    cspk: 'Odds awal',
    jspk: 'Odds saat ini',
    qy: 'Pemain',
    sf: 'Starter',
    mtsc: '(3 kali sehari)',
    sq: 'Sembunyikan',
    sfzr: 'Formasi starter',
    tbzr: 'Cadangan',
    zx: 'Formasi',
    chu: 'Awal',
    ji: 'Saat ini',
    lhyh: 'Kuning',
    wl: 'Bunuh',
    sjhgscw: 'Format nomor ponsel salah',
    inputsjyzm: 'Masukkan kode verifikasi ponsel',
    inputzonecode: 'Masukkan kode area',
    loginsuccback: 'Login berhasil, kembali ke beranda dalam 3 detik',
    loginsucc: 'Login berhasil,',
    threeback: 'Detik kembali ke beranda',
    loginfail: 'Login gagal.',
    welcome: 'Selamat datang ',
    logintips: 'Masuk nomor ponsel',
    integralExchange: "Penukaran sukses",
    integralSuccess: "Selamat, Anda telah berhasil menukar",
    integralExchanged: "Poin telah ditukar",
    integralNumber: 'Sisa poin',
    integralContinue: 'Lanjutkan penukaran',
    integralTips: '*Mohon lengkapi alamat pengiriman Anda di dalam barang tukar, staf akan mengirimkan secara otomatis setelah dikonfirmasi, karena alasan sistem, tidak dapat memberikan informasi pengiriman;',
    texttoolong: 'Karakter tidak boleh lebih dari 6',
    nickMdySucc: 'Berhasil mengubah nama panggilan',
    onlyUseChina: 'Nama panggilan hanya boleh menggunakan huruf Cina, harap masukkan kembali',
    tambahalamat: 'Tambah Alamat',
    detailalamat: 'Masukkan detail alamat, wilayah, dan informasi nomor rumah',
    inputdetail: '*Catatan: Pastikan barang dapat dikirim dengan benar ke alamat Anda. Alamat harus diisi dengan lengkap, hanya ada satu kesempatan pengisian, setelah selesai, barang akan dikirim dalam waktu 1-3 hari kerja.',
    integralex: 'Diperoleh melalui penukaran poin',
    delaccount: "Silakan baca dengan cermat untuk menutup akun, peringatan:",
    delaccontent1: "Untuk mencegah operasi yang tidak disengaja, harap konfirmasi kembali apakah Anda ingin menutup akun dan pastikan dampak setelah penutupan. Peringatan dengan niat baik, penutupan akun adalah operasi yang tidak dapat dipulihkan, disarankan untuk mencadangkan semua informasi terkait akun sebelum memutuskan untuk menutup dan pastikan semua layanan terkait akun telah ditangani dengan baik. Termasuk tetapi tidak terbatas pada:",
    delaccontent2: "1. Informasi pribadi dan riwayat akun ini (termasuk avatar, pengguna, konten yang dipublikasikan, riwayat penelusuran, dll) tidak akan dapat dipulihkan.",
    delaccontent3: "2. Anda tidak akan bisa masuk dan menggunakan akun ini.",
    delaccontent4: "3. Akun terkait pihak ketiga yang menggunakan akun ini untuk masuk atau otorisasi tidak akan dapat dipulihkan. Anda tidak akan bisa masuk menggunakan layanan tersebut, hak virtual yang Anda peroleh dan manfaat lainnya akan dianggap telah Anda lepaskan dan tidak dapat digunakan lagi. Anda memahami dan setuju bahwa aplikasi ini tidak dapat membantu Anda mengembalikan layanan tersebut. Setelah akun ditutup, nomor telepon yang terhubung akan dilepas dan dapat didaftarkan lagi, harap berhati-hati.",
    delaccontent5: "Masukkan UID lengkap Anda saat ini dan klik konfirmasi, akun Anda akan dihapus secara permanen dan tidak dapat dipulihkan, harap pertimbangkan dengan hati-hati!!!",
    delaccontent6: "Harap masukkan UID lengkap",
    delaccontent7: "Harap masukkan UID",
    delaccontent8: "UID yang Anda masukkan tidak benar",
    submitted: 'diserahkan',
    success: 'kesuksesan',
    failed: 'gagal',
    invitecode: 'Kode undangan',
    inputInviteCode: 'Opsional',
    withdrawFailed: 'Penukaran gagal',
    inputaccount: 'Silakan masukkan akun (6-20 huruf + angka)',
    inputpassword: 'Masukkan kata sandi (6-20 digit atau huruf).',
    inputpasswordagain: 'Silakan masukkan kata sandi lagi.',
    accountInvalid: 'Akun tidak sesuai dengan ketentuan.',
    gotoLogin: 'Masuk sekarang',
    gotoRegister: 'Daftar sekarang',
    querenpwd: 'Konfirmasi Kata Sandi',
    inputnickname: 'Masukkan nama panggilan',
    register: 'Daftar Akun',
    pwsswordInvalid: 'Silakan masukkan kata sandi dengan benar.',
    pwsswordNotSame: 'Kata sandi yang dimasukkan tidak cocok.',
    setAccPwd: 'Atur Kata Sandi Akun',
    setAccPwdSubTitle: 'Setelah berhasil diatur, Anda dapat menggunakan akun dan kata sandi untuk masuk.',
    inputOldPassword: 'Silakan masukkan kata sandi lama.',
    newPassword: 'Kata Sandi Baru',
    oldPassword: 'Kata Sandi Lama',
    passwordIsSame: 'Kata sandi baru tidak boleh sama dengan kata sandi lama.',
    accPwdError: 'Akun atau kata sandi tidak benar.',
    nickNameErr: 'Nama panggilan harus terdiri dari 6-20 huruf, angka, atau karakter umum.',
    accountRepeated: 'Akun tersebut sudah ada.',
    nicknameRepeated: 'Nama panggilan tersebut sudah ada.',
    setSucc: 'Pengaturan informasi berhasil.',
    regSucc: 'Pendaftaran berhasil, sedang masuk secara otomatis.',
    switchAccount: 'Ganti Akun',
  },
  'jinqiu': 'Gol',
  'focuSucc': 'Berhasil Mengikuti',
  'cancelFocus': 'Berhasil Membatalkan Mengikuti',
  'clearCache': 'Bersihkan Cache',

  "复制": "Salin",
  "邀请的人数": "Jumlah Undangan",
  "查看记录": "Lihat Catatan",
  "可兑换积分": "Poin yang Dapat Ditukar",
  "兑换话费": "Tukar Pulsa",
  "兑换彩金": "Tukar Bonus",
  "立即邀请": "Undang Sekarang",
  "记录": "Catatan",
  "好友记录": "Catatan Teman",
  "兑换记录": "Catatan Penukaran",
  "兑换": "Tukar",
  "确认兑换奖金吗？": "Konfirmasi tukar bonus?",

  "规则": "Aturan",
  "碎片": "Fragmen",
  "转盘次数": "Putaran",
  "奖品兑换": "Tukar",
  "每日奖励": "Hadiah Harian",
  "每日登录JALALIVE并观看比赛": "Login harian JALALIVE & tonton pertandingan",
  "转盘机会 +1": "+1 Putaran",
  "活动规则": "Aturan Acara",
  "确认兑换吗？": "Konfirmasi penukaran?",
  "谢谢惠顾": "Terima kasih",
  "恭喜您获得": "Selamat!",
  "未达成": "Belum",
  "领取": "Klaim",
  "已领取": "Diklaim",
  "数据异常或网络异常": "Kesalahan data/jaringan",
  "兑换成功": "Penukaran berhasil",
  "兑换失败": "Penukaran gagal",
  "收下": "Terima",
  "立即参与": "Gabung",

  "兑换奖品":"Tukar Hadiah",
  "兑换积分":"Tukar Poin",
  "兑换奖励":"Tukar Hadiah",
  "前往JalaLive积分商城":"Kunjungi Mall Poin JalaLive",
  "积分可以去兑换商品":"Poin dapat ditukar dengan barang",
  "前往":"Pergi",

  "非法手机号": "Nomor telepon tidak valid",
  "发送短信失败": "Gagal mengirim SMS",
  "温馨提示": "Pengingat",
  "您尝试登录的手机号已存在绑定的账号，请使用账号密码登录。平台即将移除手机号验证码登录方式": "Nomor ponsel ini sudah terhubung dengan akun. Silakan masuk menggunakan kata sandi akun. Login SMS akan segera dihentikan.",
  "我知道啦": "Dimengerti",
  "通知": "Pemberitahuan",
  "平台即将移除手机号验证码登录方式，系统已自动为您生成账号，请补全其他信息，后续请使用账号密码登录！": "Login SMS akan segera dihapus. Akun telah dibuat otomatis untuk Anda. Silakan lengkapi profil dan gunakan kata sandi akun untuk masuk.",
  "账号（不可更改）": "Akun (tidak dapat diubah)",
  "设置密码": "Atur kata sandi",
  "请输入密码": "Silakan masukkan kata sandi",
  "设置邮箱（用于找回密码，可选）": "Atur email (opsional untuk pemulihan kata sandi)",
  "请输入邮箱": "Silakan masukkan email",
  "忘记密码？": "Lupa sandi?",
  "邮箱验证": "Verifikasi email",
  "请输入验证码": "Silakan masukkan kode",
  "获取验证码": "Dapatkan kode",
  "邮箱格式不正确": "Format email tidak valid",
  "温馨提示：如果您没有绑定过邮箱，请联系客服找回密码": "Pengingat: Jika Anda belum mengaitkan email, silakan hubungi layanan pelanggan untuk memulihkan kata sandi",
  "设置邮箱":"Atur email",
  "温馨提示：绑定邮箱可用于找回密码":"Pengingat: Menautkan email dapat digunakan untuk memulihkan kata sandi Anda",

  "奖品剩余：": "Sisa Hadiah:",
  "VIP折扣说明": "Penjelasan Diskon VIP",
  "VIP折扣": "Diskon VIP",
  "无折扣": "Tanpa Diskon",
  "折": "Diskon",
  "查看VIP详情": "Lihat Detail VIP",
  "礼物折扣": "Diskon Hadiah",
  "支付":"Bayar",

  "竞猜":"Tebak",
  "我的积分":"Poin saya",
  "竞猜记录":"Riwayat tebak",
  "截止时间":"Batas waktu",
  "选择下注积分": "Pilih jumlah poin taruhan",
  "下注": "Taruhan",
  "下注成功": "Taruhan berhasil",
  "比赛":"Pertandingan",
  "竞猜结果":"Hasil tebakan",
  "竞猜成功":"Tebakan berhasil",
  "竞猜失败":"Tebakan gagal",
  "未开奖":"Belum pengundian",
  "投注失败，积分不足": "Taruhan gagal, poin tidak cukup",

  "（主）": "(Home)",
  "（客）": "(Away)",
  "主队赢": "Home Wins",
  "客队赢": "Away Wins",
  "平": "Seri",
  "版本":"Versi",
  "查看详情":"Lihat Detail",
  
  "(在线中…)": "(Sedang online...)",
  "暂无群组": "Belum ada grup",
  "暂无与主播私聊信息": "Belum ada chat pribadi",
  "请找主播添加您进群获得福利": "Chat host untuk masuk grup dan dapat bonus",
  "请私信主播吧~": "DM host ya~",
  "主播私聊": "DM host",
  "群组": "Grup",
  "发送":"Kirim",

  "您的聊天已受限，请联系主播或客服":"Chat dibatasi. Hubungi host atau CS.",
  "发送失败，未知错误":"Gửi gagal. Lỗi không xác định.",
};
